import { __require as requireFunctionBind } from '../function-bind/index.js';
import { __require as requireFunctionApply } from './functionApply.js';
import { __require as requireFunctionCall } from './functionCall.js';
import { __require as requireReflectApply } from './reflectApply.js';

var actualApply;
var hasRequiredActualApply;

function requireActualApply () {
	if (hasRequiredActualApply) return actualApply;
	hasRequiredActualApply = 1;

	var bind = requireFunctionBind();

	var $apply = requireFunctionApply();
	var $call = requireFunctionCall();
	var $reflectApply = requireReflectApply();

	/** @type {import('./actualApply')} */
	actualApply = $reflectApply || bind.call($call, $apply);
	return actualApply;
}

export { requireActualApply as __require };
